(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mc-global-css"]) return;
  try {
    
(function(){
  function go(){
    document.querySelectorAll('a[href$="/cart"]').forEach(function(a){var sr=a.querySelector('.sr-only');if(sr){var rest=(a.textContent||'').replace(sr.textContent,'');if(/cart/i.test(rest)){sr.remove();}}});
    document.querySelectorAll('.fyn__skip').forEach(function(b){b.textContent='Show My Number Now';});
    document.querySelectorAll('.fyn__fine').forEach(function(p){p.textContent='No noise. No over-sending. Letters from Milan only.';});
  }
  if(document.readyState!=='loading'){go();}else{document.addEventListener('DOMContentLoaded',go);}
})();

  } catch(e) { console.error(e); }
})();
})();
